/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

type MoneyPaidType = {
  amountPaid: number;
  moneyBack: number;
};

@Injectable({
  providedIn: 'root'
})
export class MoneyBackSaleService {
  private data: MoneyPaidType;

  constructor() {
    this.data = {
      amountPaid: 0,
      moneyBack: 0
    };
  }

  getData() {
    return this.data;
  }

  setData(data) {
    this.data = {
      ...data
    };
  }
}
